import { TwoColumnLayout } from '@factorialco/f0-react'
import { Dashboard } from '@factorialco/f0-react/dist/experimental'
import { DealDetailFragment } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { DealDetailsInfo } from 'modules/finance/components/Deals/DealDetailsInfo'
import {
  DealProgressWidget,
  EstimatedValueWidget,
  ExpectedCloseDateWidget,
} from 'modules/finance/components/Deals/Widgets'

interface OverviewInformationProps {
  deal: DealDetailFragment
  onOpenUpdateModal: () => void
}

const OverviewInformation: React.FC<OverviewInformationProps> = ({ deal, onOpenUpdateModal }) => {
  const { employee } = useCurrentSession()

  if (!employee) {
    return <NotFound />
  }

  const mainContent = (
    <>
      <Dashboard widgetWidth="sm">
        <EstimatedValueWidget deal={deal} onEditAmount={onOpenUpdateModal} />
        <DealProgressWidget deal={deal} />
        <ExpectedCloseDateWidget deal={deal} onAddCloseDate={onOpenUpdateModal} />
      </Dashboard>
    </>
  )

  const sideContent = <DealDetailsInfo deal={deal} />

  return <TwoColumnLayout sideContent={sideContent}>{mainContent}</TwoColumnLayout>
}

export default OverviewInformation
